import { useAtom } from 'jotai';
import { useEffect } from 'react';

import useAuth from './useAuth';

import { runInitFirebase } from '@/services/pushNotifications';
import { popupPushNotificationsAtom } from '@/store/popupPushNotifications';

let isFirebaseInitialized = false;

const onCleanup = () => {
  isFirebaseInitialized = true;
};

/**
 * Determina si se debe mostrar el popup de notificaciones.
 * Detecta el login del usuario, e inicializa Firebase.
 * @returns { popupAtom, setPopupAtom } - Devuelve la visibilidad del popup de notificaciones push
 * y una función para ocultarlo.
 */
export const usePopupPushNotifications = () => {
  const [popupAtom, setPopupAtom] = useAtom(popupPushNotificationsAtom);
  const { userInitialData } = useAuth();
  const idUsuarioDT = userInitialData?.idUsuarioDT || -1;

  useEffect(() => {
    if (idUsuarioDT === -1) {
      return;
    }
    if (isFirebaseInitialized) {
      return;
    }
    runInitFirebase(({ askForPermission }) => {
      if (askForPermission) {
        setPopupAtom({ show: true });
      } else {
        setPopupAtom({ show: false });
      }
    });
    return onCleanup;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idUsuarioDT]);

  return { popupAtom, setPopupAtom };
};
